<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title">广告主</span>
        <el-input v-model="parameter.account_id" />
      </div>
      <div class="item">
        <span class="item_title">日期</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <div class="item">
        <span class="item_title">素材类型</span>
        <el-select
          v-model="parameter.type"
          style="margin-right: 20px"
          placeholder="请选择"
          filterable
          :clearable="true"
          @clear="parameter.type = null"
        >
          <el-option
            v-for="(item, index) in [{name:'正方形图片', id: 1 }, {name: '视频', id:2}, {name:'长方形图片', id:3}]"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
      <el-button style="height:37px" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-refresh-left" @click="reset">重置</el-button>
    </div>
    <div v-if="tableData && tableData.list" v-loading="loading" class="el_row">
      <div v-for="(item, index) in tableData.list" :key="index" class="adItem">
        <el-card :body-style="{ padding: '0px'}">
          <div class="picInfo" @click="showPreview(item)">
            <video v-if="item.type === 2" :src="item.preview_url" class="image" />
            <img v-else :src="item.preview_url" class="image">
          </div>
          <div class="context">
            <div>
              <span>{{ item.account_id }}</span>
              <div v-if="item.type === 2" class="flex_row">
                <i class="el-icon-caret-right tag" />
                <i class="text">video</i>
              </div>
              <span v-else class="time" style="margin-left:auto;margin-top: 0px">{{ item.width }} x {{ item.height }}</span>
            </div>
            <div>
              <span class="time">{{ item.date_time }}</span>
              <el-tooltip effect="dark" :content="item.user_name">
                <span class="flex_row aline1" style=" text-align: right;">{{ item.user_name }}</span>
              </el-tooltip>

            </div>
          </div>
        </el-card>
      </div>
    </div>
    <div v-if="!tableData || !tableData.list || !tableData.list.length" class="emput">暂无数据</div>
    <div>

      <pagination-right
        title=""
        :total="tableData.count"
        :page-size="50"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />

      <div
        v-if="dialogVisible"
        class="preview_box"
        @click="closeDialog"
      >
        <div v-if="previewInfo.type === 2" class="info" :style="{'max-height': innerHeight +'px','max-width': innerWidth +'px'}">
          <el-button class="close_btn" @click="closeDialog">
            <i class="el-icon-close" />
          </el-button>
          <video
            :src="previewInfo.preview_url"
            style="width:100%;height:100%"
            autoplay
            loop
            muted
          />
        </div>
        <div v-else class="info">
          <el-button class="close_btn" @click="closeDialog">
            <i class="el-icon-close" />
          </el-button>
          <img
            :src="previewInfo.preview_url"
            :style="{'width': previewInfo.width < innerWidth ? previewInfo.width : innerWidth + 'px','height': previewInfo.height < innerHeight ? previewInfo.height : innerHeight + 'px'}"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { materialCountList } from '@/api/hugeAdvertGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        page_size: 50,
        account_id: null,
        type: null
      },
      date: [this.getNowFormatDate(window.Date.now()), this.getNowFormatDate(window.Date.now())],
      previewInfo: null,
      dialogVisible: false,
      innerHeight: window.innerHeight - 100,
      innerWidth: window.innerWidth - 300
    }
  },
  created() {
    this.getDataList()
  },
  mounted() {
    // 监听键盘按键事件
    const self = this
    this.$nextTick(() => {
      document.addEventListener('keydown', (e) => {
        if (e.keyCode === 27) {
          self.closeDialog()
        }
      })
    })
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await materialCountList({ ...this.parameter,
        start_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      this.tableData = data.data
      this.loading = false
    },

    // 分页
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getDataList()
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },
    // 搜索
    search() {
      this.parameter.page = 1
      this.getDataList()
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 50,
        account_id: null,
        type: null
      }
      this.date = []
      this.getDataList()
    },
    showPreview(item) {
      this.previewInfo = item
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    },
    getNowFormatDate(timeStamp) {
      var date = new Date(timeStamp)
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.selectionArea{
  display: flex;
  flex-wrap: wrap;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title{
      width: 80px;
       text-align: center;
       display: inline-block;
    }
    .item_input{
      width:200px
    }
  }
}
.el_row{
  display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.emput{
  color: #a0a0a0;
    font-size: 16px;
    padding: 30px;
    text-align: center;
    background: whitesmoke;
}
.adItem{
  width: 270px !important;
  margin: 20px 30px;
}
.context {
   display: flex;
   flex-direction: column;
   padding: 10px;
  }
  .context > div {
display: flex;
align-items: center;
  }
  .time{
    font-size: 13px;
    color: #999;
    margin-top: 5px;
  }
  .image {
    background: #999;
    height: 150px;
    display: block;
  }
.flex_row{
    display: flex;
    margin-left: auto;
    align-items: center;
}
.aline1 {
  width: 100px;
  color: #7da2e5;
    word-break: break-all;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
.text{
  font-size: 9px;
  color: #5454d5;
}
.tag{
    border-radius: 100%;
    margin-left: auto;
    background: #e1e1fd;
    padding: 3px;
    color: #5454d5;
}
  .preview_box{
    left: 0;
    top: 0;
    bottom:0;
    right:0;
    position: fixed;
    z-index: 99;
    background: rgba(0,0,0,0.6);
    display: flex;
    flex-direction: column;
   align-items: center;
   padding: 30px;

  }
  .picInfo{
    background: #f0f0f0;
    display: flex;
    justify-content: center;
  }
  .el-dialog{
    margin-top:100px !important
  }
  .info{
    position: relative;
  }
  .close_btn{
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 999;
    padding: 3px;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    color: white;
    background: rgba(56, 53, 53, 0.6);

  }
</style>

